export default __webpack_public_path__ + "static/media/logo.bd5035f9.svg";